import * as Joi from "joi";
import * as React from "react";
import { Button, Form as UIForm, Message, Modal } from "semantic-ui-react";
import {
  Form,
  IInterfaceFormProps,
  IInterfaceFormState,
} from "src/components/Form";

interface IInterfaceProps extends IInterfaceFormProps {
  modal: boolean;
  defaultName: string;
  closeModal: () => void;
  save: (name: string, callback: () => void) => void;
}

interface IInterfaceState extends IInterfaceFormState {
  error: any;
}

export class EditQueryNameModal extends Form<IInterfaceProps, IInterfaceState> {
  private static INITIAL_STATE = {
    data: {
      name: "",
    },
    error: null,
    errors: {},
  };

  private static schema: Joi.SchemaLike = {
    name: Joi.string().required().label("Name"),
  };
  // private static propKey(propertyName: string, value: any): object {
  //   return { [propertyName]: value };
  // }

  constructor(props: IInterfaceProps) {
    super(props, EditQueryNameModal.schema);
    this.state = {
      ...Form.FORM_INITAL_STATE,
      ...EditQueryNameModal.INITIAL_STATE,
    };
  }

  public componentDidMount = () => {
    this.setState({ data: { name: this.props.defaultName } });
  };

  public componentDidUpdate = (prevProps, prevState) => {
    if (this.props.defaultName !== prevProps.defaultName) {
      this.setState({ data: { name: this.props.defaultName } });
    }
  };

  public render() {
    const { error } = this.state;
    const { modal, closeModal } = this.props;

    return (
      <Modal dimmer={true} size="tiny" open={modal} onClose={closeModal}>
        <Modal.Header>Edit query name</Modal.Header>
        <Modal.Content>
          <UIForm onSubmit={this.handleSubmit}>
            {this.renderInput("name", "Query Name")}
            {error && <Message error={true} header={error.message} />}
          </UIForm>
        </Modal.Content>

        <Modal.Actions>
          {this.renderSubmitButton("Save")}
          <Button secondary={true} onClick={closeModal}>
            Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
  protected doSubmit(callback: () => void) {
    this.props.save(this.state.data.name, callback);
  }
}



// WEBPACK FOOTER //
// ./src/components/Query/EditQueryNameModal.tsx